
export default function formatDate(date) {
    // const months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    // const hours = date?.getHours() % 12 || 12;
    // const amPm = date?.getHours() >= 12 ? 'pm' : 'am';
    // const month = months[date?.getMonth()];
    // const day = date?.getDate();
    // const year = date?.getFullYear();
    // const minutes = (date?.getMinutes() < 10 ? '0' : '') + date?.getMinutes();
  
    // return `${day?.toString()?.length === 1 ? "0"+day : day}/${month}/${year}, ${hours?.toString()?.length===1 ? "0"+hours : hours}:${minutes?.toString()?.length===1 ? "0"+minutes : minutes} ${amPm}`;
    
    // const options = { year: 'numeric', month: 'long', day: 'numeric' };
    // return date.toLocaleDateString('en-US', options);

    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'long' });
    const year = date.getFullYear();

    // Format the date string
    const formattedDate = `${day} ${month}, ${year}`;
    return formattedDate;
  }